import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Typography } from '@mui/material'
import $ from 'jquery'

import { Logger, LoggerTypes } from '../../../../utils'
import { Accordion, AccordionDetails, AccordionSummary, Icon, iconNames } from '../../../../components'
import { setFlowGroupAttributeTab } from '../../../../actions'
import './style.scss'

export const FlowGroupsAccordion = ({ flowGroups, currentFlowGroup }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const errorOverClassName = '__elementErrorOver'
  const centerElement = $('.commonPage_container_central.twoSections')
  const rightElement = $('.commonPage_container_lateral.right')

  const [accordionExpanded, setAccordionExpanded] = useState(false)

  const onChangeAccordion = (selectedFlowId) => (e, newExpanded) => {
    e.preventDefault()
    setAccordionExpanded(newExpanded ? selectedFlowId : false)
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroupsAccordion.onChangeAccordion()', { selectedFlowId, newExpanded })
  }

  const onFlowClick = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroupsAccordion.onFlowClick()', { element_id })

    rightElement.removeClass('close').addClass('open')
    centerElement.removeClass('close').addClass('open')

    dispatch(setFlowGroupAttributeTab(element_id, { type: 'bpmn:StartEvent', id: element_id }))
  }

  const onFlowOver = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    const _el = $(`[data-element-id="${element_id}"]`)
    const _elLabel = $(`[data-element-id="${element_id}_label"]`)

    // Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroupsAccordion.onFlowOver()', { element_id })

    if (_el) {
      _el.addClass(errorOverClassName)
      if (_elLabel) {
        _elLabel.addClass(errorOverClassName)
      }
    }
  }

  const onFlowOut = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    const _el = $(`[data-element-id="${element_id}"]`)
    const _elLabel = $(`[data-element-id="${element_id}_label"]`)

    // Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroupsAccordion.onFlowOut()', { element_id })

    if (_el) {
      _el.removeClass(errorOverClassName)
      if (_elLabel) {
        _elLabel.removeClass(errorOverClassName)
      }
    }
  }

  Logger.trace(LoggerTypes.CONTAINER, 'FlowGroupsAccordion.render()', { flowGroups, currentFlowGroup })

  return (
    <div className="FlowGroupsAccordion">
      {flowGroups &&
        flowGroups.map((el, index) => (
          <Accordion
            key={`flow-action-${index}`}
            expanded={accordionExpanded === el.id}
            onChange={onChangeAccordion(el.id)}
            className={'accordionRow'}
            // expanded={el.id === currentFlowId}
          >
            <AccordionSummary aria-controls={'Flow-content'} id={'Flow-header'}>
              <Typography>
                <Icon
                  name={iconNames.BPMN}
                  size={14}
                  className={`${el.id === currentFlowGroup.id ? 'selectedFlowGroup' : null}`}
                />
                <span className={`iconAccordion ${el.id === currentFlowGroup.id ? 'selectedFlowGroup' : null}`}>
                  {el?.name || ''}
                </span>
              </Typography>
            </AccordionSummary>
            {(el?.flows &&
              el.flows.length > 0 &&
              el.flows.map((flow, i) => (
                <AccordionDetails
                  key={`flow-detail-${i}`}
                  onClick={(e) => onFlowClick(e, flow?.startAction?.element_id || null)}
                  onMouseOver={(e) => onFlowOver(e, flow?.startAction?.element_id || null)}
                  onMouseOut={(e) => onFlowOut(e, flow?.startAction?.element_id || null)}
                >
                  {(flow && flow.name) || 'N/A'}
                </AccordionDetails>
              ))) || (
              <AccordionDetails className="no-flow-found">
                {t('flowGroups.left.tabs.flow_groups.no_flows_found')}
              </AccordionDetails>
            )}
          </Accordion>
        ))}
    </div>
  )
}

FlowGroupsAccordion.displayName = 'FlowGroupsAccordion'

FlowGroupsAccordion.propTypes = {
  flowGroups: PropTypes.array.isRequired,
  currentFlowGroup: PropTypes.object
}

FlowGroupsAccordion.defaultProps = {
  flowGroups: null,
  currentFlowGroup: null
}
